"use client";
import useElementId from "../../hooks/useElementId.js";
import React from "react";
import { Provider } from "./FormControl.context.js";
import { getCaptionId } from "./FormControl.utilities.js";
const FormControl = (props) => {
    const { children, id: passedId, required, hasError, group, disabled, size } = props;
    const id = useElementId(passedId);
    const WrapperTagName = group ? "fieldset" : "div";
    const [helperRendered, setHelperRendered] = React.useState(false);
    const [errorRendered, setErrorRendered] = React.useState(false);
    const describedby = [
        helperRendered && getCaptionId(id),
        errorRendered && getCaptionId(id, "error"),
    ]
        .filter(Boolean)
        .join(" ");
    const attributes = { id, "aria-describedby": describedby };
    const errorRef = () => {
        setErrorRendered(true);
    };
    const helperRef = () => {
        setHelperRendered(true);
    };
    return (React.createElement(WrapperTagName, null,
        React.createElement(Provider, { value: { required, hasError, errorRef, helperRef, attributes, group, disabled, size } }, children)));
};
export default FormControl;
